import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  configurationSubject = new BehaviorSubject<any>({ config: {} });
  constructor(public http: HttpClient) {}

  load(url: string): Promise<any> {
    return new Promise((resolve) => {
      const subscription = this.http.get(url).subscribe(
        (config) => {
          try {
            this.configurationSubject.next(config);
            resolve(this.configurationSubject);
            subscription.unsubscribe();
          } catch (e) {
            throw new Error("Error leyendo archivo config.json");
          }
        },
        (error) => {
          throw new Error(error);
        }
      );
    });
  }

  getUrlApi(segment?: string): string {
    try {
      const { config } = this.configurationSubject.value;

      if (config) {
        const active = config?.apps?.find((val) => val.key === config.active);

        if (active) {
          if (location.protocol === "https:" && active.api.includes("http:")) {
            active.api = active.api.replace("http:", "https:");
          }

          return `${active.api}${segment || ""}`;
        }
      }

      return "";
    } catch (e) {
      throw new Error("Error reading configuration file");
    }
  }
}
